function i(n, t) {
  typeof n == "function" ? n(t) : typeof n == "object" && n !== null && "current" in n && (n.current = t);
}
export {
  i as assignRef
};
